import React from 'react';
import { money } from './earnings';

const BADGES = ['to join', 'inventory', 'monthly fee'];

// #region ZeroCostStrip
/**
 * The Brand path's "$0 to start" promise, as the solid Sunset Coral highlight card. The prepaid top-up is the brand's own
 * balance, withdrawable at any time, so it is spelled out rather than hidden.
 */
export const ZeroCostStrip: React.FunctionComponent<{ prepaidTopUp?: number }> = ({ prepaidTopUp }): React.ReactElement => (
    <div className="rounded-2xl bg-brand px-4 py-5 text-black sm:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
            <ul className="grid shrink-0 grid-cols-3 gap-2" aria-label="What it costs to start">
                {BADGES.map((label) => (
                    <li key={label} className="rounded-xl bg-white/90 px-3 py-2 text-center">
                        <span className="block font-display text-2xl font-semibold tabular-nums text-black">$0</span>
                        <span className="block whitespace-nowrap text-xs font-medium text-zinc-700">{label}</span>
                    </li>
                ))}
            </ul>
            <div>
                <p className="font-display text-lg font-semibold leading-snug sm:text-xl">You only pay when a customer orders, and by then they&rsquo;ve already paid you.</p>
                <p className="mt-1 text-sm text-black/80">
                    Your first order adds {prepaidTopUp ? money(prepaidTopUp, false) : 'a top-up'} to a prepaid balance that pays for your next orders.
                    It&rsquo;s your money, and you can withdraw it at any time.
                </p>
            </div>
        </div>
    </div>
);
